// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d7b64061","431":"195bf6c4","453":"a3bfcd73","455":"e8f2cc8a","977":"0c8eb359"}[chunkId] + ".chunk.js";
};